import { render, staticRenderFns } from "./ListInput.vue?vue&type=template&id=12990833&scoped=true&"
import script from "./ListInput.vue?vue&type=script&lang=js&"
export * from "./ListInput.vue?vue&type=script&lang=js&"
import style0 from "./ListInput.vue?vue&type=style&index=0&id=12990833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12990833",
  null
  
)

export default component.exports